import React from "react";
import { Redirect, Route } from "react-router-dom";
import requireAuth from "./requireAuth";

export default function ConditionalRoute(props) {
	if (props.condition) {
		if (props.requireAuth)
			return (
				<Route path={props.path} component={requireAuth(props.component)} />
			);
		else {
			return <Route path={props.path} component={props.component} />;
		}
	} else {
		return (
			<Route path={props.path}>
				<Redirect to="/" />
			</Route>
		);
	}
}
